const fields = [
  "prevBalance",
  "payments",
  "balance",
  "surcharge",
  "commonExpenses",
  "extraFee",
  "reserveFound",
  "commonAreas",
  "totalPeriod",
  "totalDebt",
  "income",
  "expense",
  "total",
];

export const convertNumberToCurrency = (number = 0) => {
  let value = number ?? 0;
  if (typeof value !== "number") {
    let raw =
      typeof value === "string" ? value.replace(/\s|\$/g, "") : String(value);
    let parsed = Number(raw);
    if (!Number.isFinite(parsed) && raw.includes(",")) {
      parsed = Number(
        raw
          .replace(/\./g, "")
          .replace(/,/g, ".")
      );
    }
    value = Number.isFinite(parsed) ? parsed : 0;
  }
  if (!Number.isFinite(value)) value = 0;
  const n = Number(value.toFixed(2));
  const currency = `$${new Intl.NumberFormat("de-DE").format(n)}`;
  const arr = currency.split(",");
  if (arr.length === 1) return `${currency},00`;
  else if (+arr[1] < 10) return `${currency}0`;
  return currency;
};
export const convertCurrencyToNumber = (currency) => {
  return Number(
    currency
      .split("$")[1]
      .split(".")
      .join("")
      .split(",")
      .join(".")
  );
};

export const isFieldCurrency = (field) => fields.includes(field);
